import React, { PureComponent, Fragment } from 'react'
import Loadable from 'Components/LoadableToImported'
import PropTypes from 'prop-types'
import cn from 'comma-number'
import differenceInDays from 'date-fns/differenceInDays'
import isPast from 'date-fns/isPast'
import parseISO from 'date-fns/parseISO'
import { SL_GATE } from 'Defaults/modals'
import { listedDaysFormatter, getDisplaySqft, unixTimeStampToDate } from 'Utils/listingUtils'
import Flex from 'Components/Flex'
import OpenHouseBanner from 'Components/OpenHouseBanner'
import FavouritesWrapper from 'Components/Favourites/FavouritesWrapper'

import ListingRemovalMessage from 'Components/ListingRemovalMessage'
import { ListingV2 } from 'Pages'
import { FAVOURITE_TYPES } from 'Defaults/favourites'
import FavouritesSection from 'Components/Favourites/FavouritesSection'
import EstimateAnimation from 'Components/EstimateAnimation'
import AppLink from 'Components/AppLink'

import { ImageSlider, CardFooter, LinkWrapper } from '../index'
import {
  _Unlocked,
  _ImageBox, _PreviewContent,
  _AskingPrice, _ClosePrice,
  _InfoHolder, _InfoItem,
  _Size, _ExactSize,
  _MaintHolder, _Brokerage, _Address, _Mls,
  _ListedDays, _ListingRemovalMessageContainer,
  _InstantEstimate,
} from './styles'

const TERMINATED = 'Terminated'

export const ListingBanner = Loadable({
  loader: () => import(/* wcomment: "ListingBanner" */ 'Components/ListingBanner'),
  loading: () => <div />,
  chunkName: 'ListingBanner',
})

class Unlocked extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showFullBrokerageName: false,
    }
    this.handleUnlockedClick = this.handleUnlockedClick.bind(this)
    this.openSignup = this.openSignup.bind(this)
    this.openSignupForListingImage = this.openSignupForListingImage.bind(this)
    this.handleBrokerageNameClick = this.handleBrokerageNameClick.bind(this)
  }

  UNSAFE_componentWillMount() {
    if(this.props.isMobileApp) ListingV2.preload()
  }

  handleUnlockedClick(e, futureOpenHouses) {
    e.stopPropagation()
    this.props.onListingClick(e, { listingId: this.props.id, listingUrl: this.props.url, openHouses: futureOpenHouses })
  }

  handleBrokerageNameClick(e) {
    e.preventDefault()
    e.stopPropagation()
    const status = this.state.showFullBrokerageName
    this.setState({ showFullBrokerageName: !status })
  }

  openSignup(e, gate) {
    e.preventDefault()
    e.stopPropagation()
    this.props.onRegister({
      gate,
    })
  }

  openSignupForListingImage(e) {
    this.openSignup(e, SL_GATE.LISTING_CARD_IMAGE)
  }

  renderSize(sqftCompToEst) {
    const { userIsLoggedIn, sqft, sqftMin, sqftMax, sqftSource } = this.props
    let output = getDisplaySqft(sqft, sqftMin, sqftMax, userIsLoggedIn, sqftSource)
    if(output) {
      output += ' sqft'
      return (
        <Fragment>
          <span />
          {sqft && userIsLoggedIn ? (
            <_InfoItem arrow={sqftCompToEst}>
              <_ExactSize>{output}</_ExactSize>
            </_InfoItem>
          ) : (
            output
          )}
        </Fragment>
      )
    }
  }

  render() {
    const {
      userIsLoggedIn,
      id,
      url,
      title,
      askingPrice,
      maintenanceFee,
      bedType,
      propertyType,
      bathrooms,
      parkingSpots,
      onHover,
      onMouseLeave,
      unitNumber,
      photoCount,
      mlsNumber,
      mobileBrowser,
      // sqftMin,
      // sqftMax,
      sqft,
      offer,
      status,
      showSlider,
      userScrolled,
      openNewTab,
      featured,
      bannerId,
      brokerage,
      isArchived,
      closedPrice,
      endDateUnix,
      entryDateUnix,
      dataSource = '',
      gaCategory,
      sourcePage,
      listing,
      HiddenCompareCta,
      hiddenFields,
      hasMyAgent,
      tourUrl,
      isFavouritesPage,
      gaSource,
      hideImageCount,
      estimateListing,
      showEstimate,
    } = this.props
    const { open_houses: openHouses } = listing
    const { showFullBrokerageName } = this.state
    const futureOpenHouses =
      openHouses?.filter(openHouse => !isPast(parseISO(`${openHouse.date} ${openHouse.from}`)))
    const listingHiddenFields = hiddenFields || {}
    const showBrokerage = !estimateListing
    const showMLSNumber = !(estimateListing || offer === 'Precon')
    // if Sold, slogan -> asking price -> 'SOLD'
    const listedDaysNumber = entryDateUnix ?
      differenceInDays(new Date(), new Date(entryDateUnix * 1000)) : null
    const listedDaysText = !isArchived && entryDateUnix ?
      listedDaysFormatter(unixTimeStampToDate(entryDateUnix)) : ''

    let bedCompToEst = 0
    let bathCompToEst = 0
    let parkingCompToEst = 0
    let sqftCompToEst = 0

    if(estimateListing) {
      const cardListingBedrooms = Number(bedType?.substring(0, 1)) || 0
      bedCompToEst = (

        (!cardListingBedrooms && cardListingBedrooms !== 0) ||
        (!estimateListing.beds_full && estimateListing.beds_full !== 0) ||
        cardListingBedrooms === estimateListing.beds_full
      ) ?
        0 : cardListingBedrooms > estimateListing.beds_full ? 1 : -1

      bathCompToEst = (
        (!bathrooms && bathrooms !== 0) ||
        !estimateListing.baths ||
        bathrooms === estimateListing.baths
      ) ?
        0 : bathrooms > estimateListing.baths ? 1 : -1

      parkingCompToEst = (
        (!parkingSpots && parkingSpots !== 0) ||
        !estimateListing.parking_spots ||
        parkingSpots === estimateListing.parking_spots
      ) ?
        0 : parkingSpots > estimateListing.parking_spots ? 1 : -1


      sqftCompToEst = (
        !sqft ||
        !estimateListing.sqft ||
        sqft === estimateListing.sqft
      ) ?
        0 : sqft > estimateListing.sqft ? 1 : -1
    }

    const estimatedValue = listing?.listing_estimate?.prediction?.expected
    return (
      <Fragment>
        <_Unlocked>
          <LinkWrapper
            onHover={onHover}
            onMouseLeave={onMouseLeave}
            handleUnlockedClick={this.handleUnlockedClick}
            openNewTab={openNewTab}
            isArchived={isArchived}
            futureOpenHouses={futureOpenHouses}
            listing={listing}
          >
            <_ImageBox>
              <OpenHouseBanner openHouses={futureOpenHouses}/>
              <ImageSlider
                id={id}
                isArchived={isArchived}
                photoCount={listingHiddenFields.photos ? 0 : photoCount}
                title={title}
                mlsNumber={mlsNumber}
                openSignup={this.openSignupForListingImage}
                mobileBrowser={mobileBrowser}
                showSlider={listingHiddenFields.photos ? false : showSlider}
                userScrolled={userScrolled}
                userIsLoggedIn={userIsLoggedIn}
                noLoginRequired={featured}
                dataSource={dataSource}
                gaCategory={gaCategory}
                hasMyAgent={hasMyAgent}
                tourUrl={tourUrl}
                hideImageCount={hideImageCount}
                openHouseDate={openHouses}
                listing={listing}
              />
              <ListingBanner
                isArchived={isArchived}
                listedDays={listedDaysNumber}
                endDateUnix={endDateUnix}
                bannerId={userIsLoggedIn ? bannerId || 0 : 0}
                offer={offer}
                status={status}
                featured={featured}
              />
            </_ImageBox>
          </LinkWrapper>

          <LinkWrapper
            onHover={onHover}
            onMouseLeave={onMouseLeave}
            handleUnlockedClick={this.handleUnlockedClick}
            openNewTab={openNewTab}
            isArchived={isArchived}
            futureOpenHouses={futureOpenHouses}
            listing={listing}
            noLinkTag
          >
            <_PreviewContent>
              <Flex justify="between" align="center">
                {
                  isArchived ? (
                    <_ClosePrice>
                      {
                        listingHiddenFields.prices
                          ? 'Price Not Available'
                          : closedPrice
                            ? `$${cn(closedPrice)}` : status === TERMINATED ? TERMINATED : 'TBD'}
                      {' '}{!listingHiddenFields.prices && <span> {'$' + cn(askingPrice)}</span>}
                    </_ClosePrice>
                  ) : (
                    <_AskingPrice>
                      {'$' + cn(askingPrice)}
                    </_AskingPrice>
                  )
                }
                {
                  !isArchived && !listing?.featured && (
                    <_ListedDays show={isFavouritesPage}>
                      {listedDaysText}
                    </_ListedDays>
                  )
                }

              </Flex>

              {
                showEstimate && estimatedValue && userIsLoggedIn &&
                  <_InstantEstimate>
                    <EstimateAnimation />
                    Instant Estimate: ${cn(estimatedValue)}
                  </_InstantEstimate>
              }

              <LinkWrapper
                onHover={onHover}
                onMouseLeave={onMouseLeave}
                handleUnlockedClick={this.handleUnlockedClick}
                openNewTab={openNewTab}
                isArchived={isArchived}
                futureOpenHouses={futureOpenHouses}
                listing={listing}
              >
                {unitNumber && (
                  <span>
                    {unitNumber}
                    <span>-</span>
                  </span>
                )}
                <_Address>{title}</_Address>
              </LinkWrapper>
              {
                !listingHiddenFields.listing_info && (
                  <_InfoHolder>
                    {bedType ? (
                      <Fragment>
                        <_InfoItem arrow={bedCompToEst}>{bedType !== 'Studio' ? `${bedType}BD` : 'Studio'}</_InfoItem>
                        <span role="separator" />
                        <_InfoItem arrow={bathCompToEst}>{bathrooms}BA</_InfoItem>
                        <span role="separator" />
                        <_InfoItem arrow={parkingCompToEst}>{parkingSpots || 0} Parking</_InfoItem>
                        <_Size>
                          {this.renderSize(sqftCompToEst)}
                        </_Size>
                      </Fragment>
                    ) : (
                      propertyType
                    )}
                  </_InfoHolder>
                )
              }


              <_MaintHolder>
                {
                  !listingHiddenFields.listing_info && maintenanceFee ?
                    (<div>Maint. Fee ${cn(Math.round(maintenanceFee))}</div>) : null
                }
                {
                  showMLSNumber
                    ? <_Mls noMargin={listingHiddenFields.listing_info}>MLS#: {mlsNumber}</_Mls>
                    : ''
                }
              </_MaintHolder>
              {showBrokerage && brokerage && (
                <_Brokerage
                  onClick={this.handleBrokerageNameClick}
                  showMore={showFullBrokerageName}
                >
                  {brokerage}
                </_Brokerage>
              )}
            </_PreviewContent>
          </LinkWrapper>
          <FavouritesWrapper
            item={{ ...listing, offer }}
            isArchived={isArchived}
            isFavouritesPage={isFavouritesPage}
            gaCategory={sourcePage}
            gaSource={gaSource}
          />
          {
            hiddenFields && (
              <_ListingRemovalMessageContainer>
                <AppLink
                  openNewTab={openNewTab}
                  to={`/${url}`}
                  alt={title}
                  lookupLinkData={{
                    component: 'Listing',
                    id,
                  }}
                >
                  <ListingRemovalMessage
                    showShortMessage
                    hiddenFields={hiddenFields}
                    fontSize="sm"
                    hideContactAgentText
                  />
                </AppLink>
              </_ListingRemovalMessageContainer>
            )
          }
        </_Unlocked>

        {isFavouritesPage ?
          <FavouritesSection
            item={listing}
            modelType={isArchived ? FAVOURITE_TYPES.ARCHIVE_LISTING : FAVOURITE_TYPES.LISTING}
            isArchived={isArchived}
          /> :
          !estimateListing ?
            <CardFooter
              listing={listing}
              listedDaysText={listedDaysText}
              HiddenCompareCta={HiddenCompareCta}
              gaCategory={gaCategory}
              sourcePage={sourcePage}
            />
            : ''
        }
      </Fragment>
    )
  }
}

Unlocked.defaultProps = {
  onListingClick: () => {},
}

Unlocked.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  askingPrice: PropTypes.number.isRequired,
  bathrooms: PropTypes.number,
  parkingSpots: PropTypes.number,
  userIsLoggedIn: PropTypes.bool,
  onHover: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onListingClick: PropTypes.func,
  mobileBrowser: PropTypes.bool,
  entryDateUnix: PropTypes.number,
  photoCount: PropTypes.number,
  mlsNumber: PropTypes.string,
  sqftMin: PropTypes.number,
  sqftMax: PropTypes.number,
  sqft: PropTypes.number,
  // building: PropTypes.string,
  // isSold: PropTypes.bool,
  // offer: PropTypes.string,
  // slogan: PropTypes.string,
  showSlider: PropTypes.bool,
  userScrolled: PropTypes.bool,
  unitNumber: PropTypes.number,
  bedType: PropTypes.string,
  // bedrooms: PropTypes.number,
  propertyType: PropTypes.string,
  maintenanceFee: PropTypes.number,
  openNewTab: PropTypes.bool,
  featured: PropTypes.bool,
  isArchived: PropTypes.bool,
  bannerId: PropTypes.number,
  offer: PropTypes.string,
  status: PropTypes.string,
  brokerage: PropTypes.string,
  closedPrice: PropTypes.number,
  endDateUnix: PropTypes.number,
  onRegister: PropTypes.func,
  // isNearbyListing: PropTypes.bool,
  sqftSource: PropTypes.string,
  dataSource: PropTypes.string,
  gaCategory: PropTypes.string,
  sourcePage: PropTypes.string,
  hiddenFields: PropTypes.shape({
    photos: PropTypes.bool,
    prices: PropTypes.bool,
    listing_info: PropTypes.bool,
  }),
  listing: PropTypes.shape({
    id: PropTypes.number,
    property_type: PropTypes.string,
    open_houses: PropTypes.arrayOf(PropTypes.shape({})),
    featured: PropTypes.bool,
    listing_estimate: PropTypes.shape({
      prediction: PropTypes.shape({
        expected: PropTypes.number,
      }),
    }),
  }),
  HiddenCompareCta: PropTypes.bool,
  hasMyAgent: PropTypes.bool,
  tourUrl: PropTypes.string,
  isMobileApp: PropTypes.bool,
  isFavouritesPage: PropTypes.bool,
  gaSource: PropTypes.string,
  hideImageCount: PropTypes.bool,
  showEstimate: PropTypes.bool,
  estimateListing: PropTypes.shape({
    beds_full: PropTypes.number,
    baths: PropTypes.number,
    parking_spots: PropTypes.number,
    sqft: PropTypes.number,
  }),
}

export default Unlocked
